module.exports = __webpack_public_path__ + "static/media/logo512.2bfd7bea.png";